import {
  FromServerNoteLinkedGroup,
  NoteLinkedGroup,
  ToServerNoteLinkedGroup,
} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import {prepareNotePartForSave, prepareNotePartForStore} from 'notebook/notes/NoteStoreTransforms';
import {addCid} from 'notebook/store/StoreTransformUtil';

/**
 * This function is called when receiving a NoteLinkedGroup from the
 * server before we've placed it in our Redux store or after we've
 * initially created it from the insertion modal.  Its main job is to
 * add cids to the group and its component noteParts and making sure
 * those cids are stored in the cidIdMap.
 */
export function prepareForStore<TGroupMetadata>(
  serverNoteLinkedGroup: FromServerNoteLinkedGroup<TGroupMetadata>,
  cidIdMap: CidIdMap
): void {
  addCid(serverNoteLinkedGroup, 'nlg', cidIdMap);

  for (const notePart of serverNoteLinkedGroup.containedNoteParts) {
    prepareNotePartForStore(notePart, cidIdMap);
  }
}

/**
 * This function is called before sending a NoteLinkedGroup to the server
 */
export function prepareForSave<TGroupMetadata>(
  noteLinkedGroup: NoteLinkedGroup<TGroupMetadata>,
  cidIdMap: CidIdMap,
  fileId: string
): ToServerNoteLinkedGroup<TGroupMetadata> {
  const containedNoteParts = noteLinkedGroup.containedNoteParts.map((notePart) =>
    prepareNotePartForSave(notePart, cidIdMap, fileId)
  );

  return {
    ...noteLinkedGroup,
    id: cidIdMap[noteLinkedGroup.cid] as string,
    containedNoteParts,
  };
}
